export default "__VITE_ASSET__D$LUF77W__"